import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { gutil } from '../gutil';
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { Router} from "@angular/router";
import { HttpClient } from '@angular/common/http';
import { MapsAPILoader } from '@agm/core';

@Component({
  selector: 'app-tenants',
  templateUrl: './tenants.component.html',
  styleUrls: ['./tenants.component.scss']
})
export class TenantsComponent implements OnInit {

  public homeType : string;
  public selectedCity : string;
  public cityList : Array<any>;
  public faSearch = faSearch;
  public featuredFamilyHome : Array<any>;
  public featuredCoLivHome : Array<any>;
  public featuredProperty : Array<any>;
  public coliving : boolean = true;
  public family : boolean = false;
  public featuredPropertyType : string;
  public propCount : number = 0;
  public propertyLoader : boolean = false;
  public selectedLocation: any;
  public houseType : number = 3;

  @ViewChild("search")
  public searchElementRef: ElementRef;

  @ViewChild("search_sm")
  public searchElementRef1: ElementRef;

  constructor(private router: Router, private http : HttpClient, private mapsAPILoader: MapsAPILoader) { }

  ngOnInit(): void {
    this.selectedCity = 'bengaluru';
    this.cityList = gutil.citySel;
    this.fetchFeaturedProperty('bengaluru', 'family');
    this.changeHomeType('family');
    this.featuredCoLivHome.length = 0;
    this.featuredFamilyHome.length = 0; 
    this.houseType= 3;   

    this.fetchAutoComplete(12.972442, 77.7032227);
  }

  public selectHouseType(type:number){
    this.houseType = type;
    gutil.searchData.gender = type;
  }

  public changeHomeType(value:any) {
    this.featuredPropertyType = value;
    if(value == 'coliv') {
      this.homeType = 'coliv';
      document.getElementById('coliving').classList.add('active');
      document.getElementById('family').classList.remove('active');
      this.coliving = true;
      this.family = false;      
      this.fetchFeaturedProperty(this.selectedCity, 'coliv' );
    }
    else {
      this.homeType = 'family';
      document.getElementById('coliving').classList.remove('active');
      document.getElementById('family').classList.add('active');      
      this.coliving = false;
      this.family = true;    
      this.fetchFeaturedProperty(this.selectedCity, 'family');
    }
  }

  public slideScroll(element : any,direction: string,speed: number,distance: number,step: number){
    let scrollAmount = 0;
    let slideTimer = setInterval(function(){
      if(direction == 'left'){
        element.scrollLeft -= step;
      }else{
        element.scrollLeft += step;
      }
      scrollAmount += step;
      if(scrollAmount >=distance ){
        window.clearInterval(slideTimer);
      }
    }, speed) 
  }

  //Change City
  public onSelectedCityChange(city: any) {    
    this.selectedCity = city;    
    gutil.searchData.city = city;
    if(city == 'bengaluru') {
      this.fetchAutoComplete(12.972442, 77.7032227);
    }
    else {
      this.fetchAutoComplete(18.5204, 73.8567);
    }    
    this.fetchFeaturedProperty(city, this.featuredPropertyType);
  }

  //Featured Property
  public fetchFeaturedProperty (city: string, type: string) {
    this.propertyLoader = true;
    this.featuredCoLivHome = [];
    this.featuredFamilyHome = [];

    this.http.get(gutil.apiUrl + '/api/w/v1/get/featuredprop').subscribe((data:any) => {           
      if(city == 'bengaluru') {        
        this.featuredProperty = data.data.bengaluru;
        let coliv = 0; let fam = 0;
        if(type == 'coliv') {          
          for(let i = 0; i < this.featuredProperty.length; i++) {            
            if(this.featuredProperty[i].gender == 1 || this.featuredProperty[i].gender == 2) {              
              this.featuredCoLivHome[coliv] = this.featuredProperty[i];    
              coliv++;          
            }
          }
        }
        else {
          for(let i = 0; i < this.featuredProperty.length; i++) {
            if(this.featuredProperty[i].gender == 0 ) {
              this.featuredFamilyHome[fam] = this.featuredProperty[i];       
              fam++;       
            }
          }
        }                
      }
      else {
        this.featuredProperty = data.data.pune;
        let coliv = 0; let fam = 0;
        if(type == 'coliv') {          
          for(let i = 0; i < this.featuredProperty.length; i++) {            
            if(this.featuredProperty[i].gender == 1 || this.featuredProperty[i].gender == 2) {              
              this.featuredCoLivHome[coliv] = this.featuredProperty[i];     
              coliv++;         
            }
          }
        }
        else {
          for(let i = 0; i < this.featuredProperty.length; i++) {
            if(this.featuredProperty[i].gender == 0 ) {
              this.featuredFamilyHome[fam] = this.featuredProperty[i];      
              fam++;        
            }
          }
        }                   
      }  
      this.propertyLoader = false;               
    })
  }


  ///Search Property
  public searchProperty() { 
    if(this.selectedLocation !== null && this.selectedLocation !== undefined){
      var loc = this.selectedLocation.substring(0 , this.selectedLocation.indexOf(",")).replace(" ",'-');
      if(this.houseType === 3){
        var gender = 'All';
      }
      if(this.houseType === 1){
        var gender = 'Boys';
      }
      this.router.navigate(['/'+gutil.searchData.city+'/properties-for-rent/'+ loc + '/' + gender ]).then(() => {})
    }else{
      alert("Please enter locality");
    }
  }

  // if(this.selectedLocation !== null ) {      
  //   console.log(this.houseType);
  //   var loc = this.selectedLocation.substring(0 , this.selectedLocation.indexOf(",")).replace(" ",'-');
  //   console.log(loc);
  //   let shareType = '';
  //     if(this.houseType == 0) { //Co-Living Search Result
  //       shareType = 'Co-Living'
  //       if(loc.toLowerCase() !== gutil.searchData.city.toLowerCase()) {
  //         this.router.navigate(['/'+gutil.searchData.city+'/properties-for-rent/'+loc + '/' + shareType  ]).then(() => {
  //             console.log('true');
  //         })
  //       }
  //     }
  //     else { //Family Search Result
  //       shareType = 'Family';
  //       this.router.navigate(['/'+gutil.searchData.city+'/properties-for-rent/' + loc  +'/' + shareType ]);
  //     }
  // }
  // else {
  //   console.log('run');
  //   this.router.navigate(['/'+gutil.searchData.city+'/properties-for-rent/']).then(() => {

  //   })
  // }

  //Google Autocomplete
  public fetchAutoComplete($lat:any,$lon:any){
    this.mapsAPILoader.load().then(() => {
      let defaultBounds: google.maps.LatLngBounds ;
      let options: google.maps.places.AutocompleteOptions;
      
        
      defaultBounds= new google.maps.LatLngBounds(
        new google.maps.LatLng($lat , $lon),
        new google.maps.LatLng($lat , $lon)
      );
      options = {
        bounds : defaultBounds,
        componentRestrictions : {country : 'in'}
      };
      
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement , options);
      autocomplete.addListener("place_changed", () => {
        this.selectedLocation = autocomplete.getPlace().formatted_address;
        
      })
      let autocomplete1 = new google.maps.places.Autocomplete(this.searchElementRef1.nativeElement , options);
      autocomplete1.addListener("place_changed", () => {
        this.selectedLocation = autocomplete1.getPlace().formatted_address;
        
      })
    })
  
   }

   public newsRight() {
    let content = document.getElementById('news_carousal');
    this.slideScroll(content,'right',25,150,260);
  }
  public newsLeft() {
    let content = document.getElementById('news_carousal');
    this.slideScroll(content,'left',25,150,260);
  }
  public blogRight() {
    let content = document.getElementById('blogs_carousal');
    this.slideScroll(content,'right',50,300,370);
  }
  public blogLeft() {
    let content = document.getElementById('blogs_carousal');
    this.slideScroll(content,'left',50,300,370);
  }
  public videoTestimonialRight(){
    let content = document.getElementById('testimony_carousal');
    this.slideScroll(content,'right',50,300,230);
  }
  public videoTestimonialLeft(){
    let content = document.getElementById('testimony_carousal');
    this.slideScroll(content,'left',50,300,230);
  }  
  public featPropRightIndicator() {    
    let content = document.getElementById('featuredProperty_carousal');
    this.slideScroll(content,'right',100,500,380);
  }
  public featPropLeftIndicator() {    
    let content = document.getElementById('featuredProperty_carousal');
    this.slideScroll(content,'left',50,300,370);
  }
}
